import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppRoutes } from "./routes";
import { AuthProvider } from "./contexts/AuthContext";
import { NetworkStatusProvider } from "./contexts/NetworkStatusContext";
import { AxiosInterceptor } from "./services/http/AxiosInterceptor";
import { AppThemeProvider } from "./theme";

const App: React.FC = () => {
  return (
    <NetworkStatusProvider>
      <BrowserRouter>
        <AppThemeProvider> 
          <AuthProvider>
            <AxiosInterceptor>
              <AppRoutes />
              <ToastContainer />
            </AxiosInterceptor>
          </AuthProvider>
        </AppThemeProvider>
      </BrowserRouter>
    </NetworkStatusProvider>
  );
};

export default App;
